import { Component, Input, OnInit } from '@angular/core';

import { Event, RecruitmentFormat } from '../../models';

@Component({
    selector: 'event-info',
    templateUrl: './event-info.component.html',
})
export class EventInfoComponent implements OnInit {
    @Input() event: Event;
    selectedFormats: string;
    recruitmentFormats: RecruitmentFormat[] = [
        { id: 1, name: 'Info/Pres/Demo In-Person' },
        { id: 2, name: 'Info/Pres/Demo Digital' },
        { id: 3, name: 'Instrument Fitting' },
        { id: 4, name: 'Be Part of the Music' }
    ];

    ngOnInit() {
        this.selectedFormats = this.recruitmentFormats.filter(format =>
            this.event.eventRecruitmentFormats.some(itm => itm.recruitmentFormatId == format.id))
            .map(format => format.name)
            .join(', ');
    }
}